module.exports = __webpack_public_path__ + "media/app/assets/specializations/rogue/subtlety-89d8f48f9e7e548bb0669b65795ff035.png";